export default __webpack_public_path__ + "static/media/03.fdf6588c.png";